import React, { FC, useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

const MoreActionsButton: FC<{
  feedbackRequest: any;
  onEditClick: (feedbackRequestId: number) => void;
  onDeleteClick: (feedbackRequestId: number) => void;
  onUndeleteClick: (feedbackRequestId: number) => void;
}> = ({ feedbackRequest, onEditClick, onDeleteClick, onUndeleteClick }) => {
  const { formatMessage } = useIntl();
  const [showExtraControls, setShowExtraControls] = useState(false);
  const toggle = useCallback(
    () => setShowExtraControls((prevState) => !prevState),
    []
  );

  const handleEditClick = useCallback(() => {
    onEditClick(feedbackRequest.id);
    setShowExtraControls(false);
  }, [feedbackRequest.id, onEditClick]);

  const handleDeleteClick = useCallback(() => {
    onDeleteClick(feedbackRequest.id);
    setShowExtraControls(false);
  }, [feedbackRequest.id, onDeleteClick]);

  const handleUndeleteClick = useCallback(() => {
    onUndeleteClick(feedbackRequest.id);
    setShowExtraControls(false);
  }, [feedbackRequest.id, onUndeleteClick]);

  const isDeleted = !!feedbackRequest.deleted_at;

  return (
    <Dropdown isOpen={showExtraControls} toggle={toggle} direction="end">
      <DropdownToggle tag="button" className="focusable-element">
        <span
          id={`more=actions-button-${feedbackRequest.id}`}
          className="btn btn-sm btn-outline-secondary p-1"
          aria-label={formatMessage({
            id: 'app.views.administration.content_administration.feedback_and_recognition_admin.requested.more_actions.aria_label',
            defaultMessage: 'More actions button',
          })}
          style={{
            opacity: 0.45,
          }}
        >
          <i className="fe fe-more-vertical" />
        </span>
      </DropdownToggle>
      <DropdownMenu className="pt-2 pb-2" end>
        <DropdownItem onClick={handleEditClick}>
          <i className="pe-2 fe fe-copy" />
          <FormattedMessage
            id="app.views.administration.content_administration.feedback_and_recognition_admin.requested.edit_this_feedback_request"
            defaultMessage="Edit this feedback request"
          />
        </DropdownItem>
        {!isDeleted && (
          <DropdownItem onClick={handleDeleteClick}>
            <i className="pe-2 fe fe-trash" />
            <FormattedMessage
              id="app.views.administration.content_administration.feedback_and_recognition_admin.requested.delete"
              defaultMessage="Delete this feedback request"
            />
          </DropdownItem>
        )}
        {isDeleted && (
          <DropdownItem onClick={handleUndeleteClick}>
            <i className="pe-2 fe fe-trash" />
            <FormattedMessage
              id="app.views.administration.content_administration.feedback_and_recognition_admin.requested.undelete"
              defaultMessage="Undelete this feedback request"
            />
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default React.memo(MoreActionsButton);
